import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { I18n } from 'app/components/localization';
import { setAndPersistUserLocale } from 'app/models/i18n/actions';
import { USER_LANGUAGES } from 'app/constants/enums/Language';
import LanguageDropdown from 'app/components/header/LanguageDropdown';

const LanguageDropdownInjectDependencies = (props) => {
  const makeLanguageSetter = (localizationService) => locale =>
    props.setAndPersistUserLocale(localizationService, locale);

  return (
    <I18n>{(localizationService) =>
      <LanguageDropdown
        currentLanguage={localizationService.locale}
        languages={USER_LANGUAGES}
        setLanguage={makeLanguageSetter(localizationService)}
      />
    }</I18n>
  );
};

LanguageDropdownInjectDependencies.propTypes = {
  setAndPersistUserLocale: PropTypes.func.isRequired,
};

export default connect(null, { setAndPersistUserLocale })(LanguageDropdownInjectDependencies);
